import { AbstractControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';

export function passwordConfirmValidator(passwordControlName: string, confirmPasswordControlName: string): any {
  return (group: UntypedFormGroup) => {
    const passwordControl = group.controls[passwordControlName];
    const confirmPasswordControl = group.controls[confirmPasswordControlName];
    if (passwordControl.value !== confirmPasswordControl.value) {
      return confirmPasswordControl.setErrors({ passwordNotMatch: true });
    }
    return confirmPasswordControl.setErrors(null);
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function optionalEmailValidator(emailControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl) => {
    return control.value !== '' ? Validators.email : null;
  };
}
